module.exports = __webpack_public_path__ + "static/media/loading.6bc57bab.gif";